const RAW_EMAILS = [
  "minelloandrea@gmail.com",
  "jehona@lekotech.com",
  "nikolin@lekotech.com",
];

export const RETE_RICAMBI_INTERNAL_ADMIN_EMAILS = new Set(
  RAW_EMAILS.map((e) => e.toLowerCase()),
);

export function isReteRicambiInternalAdminEmail(email) {
  if (!email) return false;
  return RETE_RICAMBI_INTERNAL_ADMIN_EMAILS.has(email.trim().toLowerCase());
}
